/* LEWD FASHION — CLOUT QUEENS alt-skin PDP reveal.
 *
 * An in-game outfit listing deliberately ships a BLACK SILHOUETTE as its only
 * product image: the copy promises the outfit "is revealed once it is yours".
 * Until this file existed the storefront did not keep that promise — the
 * reveal art and the metafields were in place but no theme code read them, so
 * an owner saw the silhouette too.
 *
 * Runs ONLY on a product carrying custom.skin_id (see the guard in
 * sections/main-product.liquid). Inert everywhere else in the store.
 *
 * ⚠️ WRITTEN AGAINST THE LF CUSTOM GALLERY, NOT DAWN. This theme's product
 * page is bespoke (#lf-pd): one <img id="lfMainImg">, a thumbnail strip whose
 * .lf-gal__thumb elements carry the full-size URL in data-src, and a lightbox
 * that reads whatever src the main image currently holds. That shape dictates
 * the work below:
 *   - the main image must be swapped by src, AND
 *   - every thumb's data-src must be swapped too, or the first thumbnail click
 *     puts the silhouette straight back on screen.
 * The lightbox needs no handling: it inherits from the main image.
 * A skin product currently has a single image, so the thumb strip is not even
 * rendered — the thumb pass is here so adding a second image later cannot
 * quietly reintroduce that bug.
 *
 * ⚠️ MATCHES ON THE LOCKED FILENAME, never on DOM position. Shopify appends
 * ?v= and width params, so compare basenames only.
 *
 * ⚠️ ENTITLEMENT IS THE SERVER'S ANSWER, NEVER THE PAGE'S. /skins reads Shopify
 * ORDERS behind a signed App Proxy. Someone can forge the DOM afterwards and
 * look at a picture they did not buy, which costs nothing: the picture is not
 * the product. The OUTFIT lives in the game and is gated by this same endpoint.
 *
 * ⚠️ FAILS CLOSED AND SILENT. Signed out (401), offline, or a bad payload all
 * leave the silhouette exactly as it is. A broken reveal must never become a
 * broken product page.
 */
(function () {
  var cfgEl = document.getElementById('lf-cq-skin-reveal');
  if (!cfgEl) return;

  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  if (!cfg || !cfg.skinId || !cfg.revealUrl || !cfg.lockedUrl) return;

  // Basename only — strip the query string and the path.
  var locked = cfg.lockedUrl.split('?')[0].split('/').pop();
  if (!locked) return;

  function swap() {
    var hit = false;

    var main = document.getElementById('lfMainImg');
    if (main && (main.getAttribute('src') || '').indexOf(locked) !== -1) {
      main.setAttribute('src', cfg.revealUrl);
      hit = true;
    }

    var thumbs = document.querySelectorAll('#lf-pd .lf-gal__thumb');
    for (var i = 0; i < thumbs.length; i++) {
      var t = thumbs[i];
      if ((t.getAttribute('data-src') || '').indexOf(locked) === -1) continue;
      t.setAttribute('data-src', cfg.revealUrl);
      var ti = t.querySelector('img');
      if (ti) ti.setAttribute('src', cfg.revealUrl);
      hit = true;
    }
    return hit;
  }

  function badge() {
    var wrap = document.querySelector('#lf-pd .lf-gal__main-wrap');
    if (!wrap || document.getElementById('lfSkinOwned')) return;
    var b = document.createElement('span');
    b.id = 'lfSkinOwned';
    b.textContent = 'UNLOCKED';
    // Mirrors .lf-gal__counter (which sits bottom-right) on the opposite corner,
    // in brand rose rather than the counter's neutral scrim.
    b.style.cssText = 'position:absolute;top:12px;left:12px;background:#e8457a;'
      + 'color:#fff;font-size:10px;font-weight:700;letter-spacing:.1em;'
      + 'padding:4px 10px;border-radius:100px;pointer-events:none;z-index:1;'
      + "font-family:'Futura PT','Futura',sans-serif;";
    wrap.appendChild(b);
  }

  fetch('/apps/clout-queens/skins', {
    headers: { accept: 'application/json' },
    credentials: 'same-origin'
  })
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (d) {
      if (!d || !Array.isArray(d.skins)) return;
      if (d.skins.indexOf(cfg.skinId) === -1) return;   // not an owner
      if (swap()) badge();

      // ⚠️ SILENCE THE STALE LOCKED COPY IN snippets/lf-skin-reveal.liquid.
      // That block decides owned/locked from customer.metafields.clout_queens
      // .skins, which the Worker refreshes at most every 12 HOURS — so a
      // customer who bought minutes ago gets the revealed hero (this file, live)
      // sitting directly above "the outfit is hidden on purpose" (that file,
      // cached). We just got the authoritative answer, so drop the paragraph.
      // Only ever REMOVES the locked state; it never fabricates the owned one.
      var stale = document.querySelector('.lf-skin-reveal__locked');
      if (stale && stale.parentNode) stale.parentNode.removeChild(stale);
    })
    .catch(function () { /* silhouette stays */ });
}());
